import React, { useEffect, useState } from "react"
import { CardText, Col, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Label, Input } from "reactstrap"

import moment from "moment"
import ReactPaginate from "react-paginate"
import DPDynamicTablePopUp from "framework/components/DPDynamicTablePopUp"

const VendorMasterTab6 = ({
  strSupplierCode,
  handleClear
}) => {
  const [ledgerDetails, setLedgerDetails] = useState([])
  const [dateRangeLabel, setDateRange] = useState("Today")
  const [fromDate, setFromDate] = useState(moment(Date.now()).format("YYYY-MM-DD"))
  const [toDate, setToDate] = useState(moment(Date.now()).format("YYYY-MM-DD"))
  const [isProcessed, setIsProcessed] = useState(2)
  const [isProcessedLabel, setIsProcessedLabel] = useState("All")
  const [ledgerActive, setLedgerActive] = useState(false)

  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const toggle1 = () => setDropdownOpen1(prevState => !prevState);

  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const toggle2 = () => setDropdownOpen2(prevState => !prevState);

  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const toggle3 = () => setDropdownOpen3(prevState => !prevState);

  var days = [{
    label: "Today",
    startDate: moment(Date.now()).format("YYYY-MM-DD"),
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  },
  {
    label: "Yesterday",
    startDate: moment(Date.now()).subtract(1, "days").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).subtract(1, "days").format("YYYY-MM-DD")
  },
  {
    label: "Last 7 Days",
    startDate: moment(Date.now()).subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  },
  {
    label: "Last 30 Days",
    startDate: moment(Date.now()).subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  },
  {
    label: "This Month",
    startDate: moment(Date.now()).startOf("month").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  },
  {
    label: "Last Month",
    startDate: moment(Date.now()).subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).subtract(1, "month").endOf("month").format("YYYY-MM-DD")
  },
  {
    label: "This Year",
    startDate: moment(Date.now()).startOf("year").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  },
  {
    label: "Last Year",
    startDate: moment(Date.now()).subtract(1, "year").startOf("year").format("YYYY-MM-DD"),
    endDate: moment(Date.now()).subtract(1, "year").endOf("year").format("YYYY-MM-DD")
  },
  {
    label: "Lifetime",
    startDate: "1900-01-01",
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  },
  {
    label: "Custom",
    startDate: moment(Date.now()).format("YYYY-MM-DD"),
    endDate: moment(Date.now()).format("YYYY-MM-DD")
  }
  ]

  var processed = [{
    label: "All",
    value: 2
  },
  {
    label: "Processed",
    value: 1
  },
  {
    label: "Unprocessed",
    value: 0
  }
  ]

  useEffect(() => {
    setLedgerDetails([])
    setLedgerActive(false)
    setDateRange("Today")
    setFromDate(moment(Date.now()).format("YYYY-MM-DD"))
    setToDate(moment(Date.now()).format("YYYY-MM-DD"))
    setIsProcessed(2)
    setIsProcessedLabel("All")
    setLedgerActive(false)

  }, [handleClear])

  useEffect(() => {
    if (strSupplierCode == "") {
      setLedgerDetails([])

      return
    }
    if (ledgerActive) {
      getLedgerDetails()
    }

  }, [fromDate, toDate, isProcessed])

  async function getLedgerDetails() {
    if (strSupplierCode == "") return
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    fetch(`${ApiURL}common/ledger/${1}/${strSupplierCode}/${isProcessed}/${fromDate}/${toDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {

        //setLedgerDetails(responseData.data)

        var resData = responseData.data

        const grouped = resData.reduce((acc, curr) => {
          const key = `${curr.heD_TXNDATE.slice(0, 10)}-${curr.heD_TYPE.slice(1, 4)}`;
          if (!acc[key]) {
            acc[key] = {
              data: [],
              heD_TXNDATE: curr.heD_TXNDATE.slice(0, 10),
              heD_TYPE: curr.heD_TYPE,
              heD_GROAMT: 0,
              heD_NETAMT: 0,
              heD_REF1: "",
              heD_REF2: "",
              heD_REFTYPE: "",
              heD_REFNO: "",
              heD_DISAMT: 0,
              heD_DISCPER: 0,
            };
          }
          acc[key].data.push(curr);
          acc[key].heD_GROAMT = acc[key].data.reduce((acc, curr) => acc + curr.heD_GROAMT, 0)
          acc[key].heD_DISAMT = acc[key].data.reduce((acc, curr) => acc + curr.heD_DISAMT, 0)
          acc[key].heD_NETAMT = acc[key].data.reduce((acc, curr) => acc + curr.heD_NETAMT, 0)
          return acc;
        }, []);


        //convert to array
        const result = Object.keys(grouped).map(key => {
          return grouped[key];
        });

        setLedgerDetails(result)



      }).catch(err => {
        console.log(err)
      })
  }



  return (
    <React.Fragment>
      <div style={{ paddingTop: "1rem" }}>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <Label>Filter Datails:</Label>
              </Row>
              <Row>
                <Col sm={12} md={1} className="mb-4-sm">
                  <label>Period</label>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                  <Dropdown isOpen={dropdownOpen1} toggle={toggle1}>
                    <DropdownToggle caret size='sm'>
                      {dateRangeLabel}
                    </DropdownToggle>
                    <DropdownMenu>
                      {days.map((item, index) => {
                        return (
                          <DropdownItem key={index} onClick={e => {
                            setDateRange(item.label)
                            setFromDate(item.startDate)
                            setToDate(item.endDate)
                          }} >{item.label}</DropdownItem>
                        )
                      })}
                    </DropdownMenu>
                  </Dropdown>
                </Col>

                {dateRangeLabel == "Custom" ? <Col sm={12} md={2} className="mb-4-sm">
                  <div style={{ display: 'inline-block', paddingRight: '5px' }}>
                    <label>From</label>
                  </div>
                  <div style={{ display: 'inline-block' }}>
                    <Input type="date" size='sm' value={fromDate} onChange={e => {
                      setFromDate(e.target.value)
                    }} />
                  </div>
                </Col> : null}
                {dateRangeLabel == "Custom" ? <Col sm={12} md={2} className="mb-4-sm">
                  <div style={{ display: 'inline-block', paddingRight: '5px' }}>
                    <label>To</label>
                  </div>
                  <div style={{ display: 'inline-block', paddingRight: '5px' }}>
                    <Input type="date" size='sm' value={toDate} onChange={e => {
                      setToDate(e.target.value)
                    }} />
                  </div>
                </Col> : null}

                <Col sm={12} md={1} className="mb-4-sm">
                  <label>Status</label>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                  <Dropdown isOpen={dropdownOpen2} toggle={toggle2}>
                    <DropdownToggle caret size='sm'>
                      {isProcessedLabel}
                    </DropdownToggle>
                    <DropdownMenu>
                      {processed.map((item, index) => {
                        return (
                          <DropdownItem key={index} onClick={e => {
                            setIsProcessed(item.value)
                            setIsProcessedLabel(item.label)
                          }} >{item.label}</DropdownItem>
                        )
                      })}
                    </DropdownMenu>
                  </Dropdown>
                </Col>
                <Col className='text-end'>
                  <Button color="primary" style={{ width: "100px" }} size="sm" onClick={e => {
                    getLedgerDetails()
                    setLedgerActive(true)
                  }}>Load ledger</Button>
                </Col>
              </Row>

              <Row>
                <TableWithPagination
                  DataTables={ledgerDetails}
                />
              </Row>
              <Row>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default VendorMasterTab6



const TableWithPagination = ({ DataTables, handleSwitchChanges, change, disabled }) => {



  const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [toggle, setToggle] = useState(false)
  const [mainTitle, setMainTitle] = useState("")

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  // const currentPosts = DataTable.slice(indexOfFirstPost, indexOfLastPost)

  const currentPosts = DataTables.slice(indexOfFirstPost, indexOfLastPost)

  useEffect(() => {
    setCurrentPage(1)
  }, [change])

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  function handleRowOnClick(data, date, type) {

    if (toggle) {
      setFilteredData([])
    } else {
      setFilteredData(data)
      setMainTitle(date + " - " + type)
    }
    setToggle(!toggle)
  }


  return (
    <React.Fragment>
      <Row className='mt-2'>
        <table className="table table-bordered  table-sm rounded" style={{ fontSize: "11px" }} id={"TaxmodeDet"}>
          <thead className="table-light">
            <tr>
              <th>Transaction Date</th>
              <th>Transaction type</th>
              <th style={{ textAlign: "right" }}>Total Transactions</th>
              {/* <th>Reference 1</th>
              <th>Reference 2</th>
              <th>Ref Type</th>
              <th>Ref Number</th> */}
              <th style={{ textAlign: "right" }}>Gross amount</th>
              {/* <th style={{ textAlign: "right" }}>Discount Amt</th>
              <th style={{ textAlign: "right" }}>Discount Per</th> */}
              <th style={{ textAlign: "right" }}>Net Amount</th>
            </tr>
          </thead>
          <tbody disabled={true}>
            {(currentPosts || []).map((values, index) => (
              <tr onClick={e => {
                handleRowOnClick(values.data, values.heD_TXNDATE.slice(0, 10), values.heD_TYPE)
              }}>
                <td style={{ width: "100px", margin: "auto" }}>{values.heD_TXNDATE.slice(0, 10)}</td>
                <td style={{ width: "300px", margin: "auto" }}>{values.heD_TYPE}</td>
                <td style={{ width: "100px", textAlign: "right", margin: "auto" }}>{values.data.length}</td>
                {/* <td style={{ width: "100px", margin: "auto" }}>{values.heD_REF1}</td>
                <td style={{ width: "100px", margin: "auto" }}>{values.heD_REF2}</td>
                <td style={{ width: "100px", margin: "auto" }}>{values.heD_REFTYPE}</td>
                <td style={{ width: "100px", margin: "auto" }}>{values.heD_REFNO}</td> */}
                <td style={{ textAlign: "right", width: "100px" }}>{(values.heD_GROAMT).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                {/* <td style={{ textAlign: "right", width: "80px" }}>{(values.heD_DISAMT).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                <td style={{ textAlign: "right", width: "80px" }}>{(values.heD_DISCPER).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td> */}
                <td style={{ textAlign: "right", width: "100px" }}>{(values.heD_NETAMT).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3" style={{ textAlign: "right" }}>Total</td>
              <td style={{ textAlign: "right" }}>{(DataTables.reduce((a, b) => a + parseFloat(b.heD_GROAMT), 0)).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
              <td style={{ textAlign: "right" }}>{(DataTables.reduce((a, b) => a + parseFloat(b.heD_NETAMT), 0)).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
            </tr>
          </tfoot>
        </table>
      </Row>

      <Row className='mt-2'>
        <Col md="12">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataTables.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-end pagination-sm'}
          />
        </Col>

        <DPDynamicTablePopUp
          data={filteredData}
          isOpen={toggle}
          toggle={handleRowOnClick}
          mainTitle={mainTitle}
        />

      </Row>

    </React.Fragment>
  )
}